// @flow

import SecurityContext from './SecurityContext'

export default class CartModifiersPermissions {

  canRead(proRole: ProRole = null): boolean {
    return SecurityContext.havePermission(
      'restaurantMenu.cartModifiers',
      proRole
    )
  }

  canEdit(proRole: ProRole = null): boolean {
    return SecurityContext.havePermission(
      'restaurantMenu.cartModifiers.canEdit',
      proRole
    )
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/permissions/CartModifiersPermissions.js